import React from 'react';

const AllianceDefense = () => {
  return <h1>AllianceDefense Page</h1>;
};

export default AllianceDefense;
